import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import FormValidation from "../../../Common/FormValidation";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import { LoaderComponent } from "../../../Common/LoaderComponent";

const BankCreate = () => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({
    status: "active",
  });
  const [error, setError] = useState({});

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const formSubmit = () => {
    Http.post("/accounts/banks", inputs)
      .then((res) => {
        navigate("/bank", {
          state: { message: res.data.message, type: "success" },
        });
      })
      .catch(function (e) {
        setError(e.response.data.errors);
      });
  };

  return (
    <div>
      <IsLogin></IsLogin>
      <LoaderComponent />
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Create Bank</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <h6 className="card-body-title mg-sm-b-30">Bank Information</h6>
            <div className="row">
              <div className="col-lg">
                <FormValidation error={error} />
              </div>
            </div>
            <div className="row">
              <div className="col-lg">
                <label>Bank Name <span className="text-danger">*</span></label>
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  value={inputs.name || ""}
                  onChange={handleChange}
                  placeholder="Enter Bank Name"
                />
              </div>
              <div className="col-lg">
                <label>Account Number <span className="text-danger">*</span></label>
                <input
                  type="text"
                  className="form-control"
                  name="account_number"
                  value={inputs.account_number || ""}
                  onChange={handleChange}
                  placeholder="Enter Account Number"
                />
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-lg">
                <label>Branch Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="branch"
                  value={inputs.branch || ""}
                  onChange={handleChange}
                  placeholder="Enter Branch Name"
                />
              </div>
              <div className="col-lg">
                <label>Initial Balance</label>
                <input
                  type="number"
                  className="form-control"
                  name="balance"
                  value={inputs.balance || ""}
                  onChange={handleChange}
                  placeholder="Enter Initial Balance"
                />
              </div>
            </div>

            <div className="row mt-3">
              {/* <div className="col-lg">
                <label>Description</label>
                <textarea
                  className="form-control"
                  name="description"
                  value={inputs.description || ""}
                  onChange={handleChange}
                  placeholder="Enter Description"
                  rows="3"
                ></textarea>
              </div> */}
              <div className="col-lg-3">
                <label>Status</label>
                <select
                  className="form-control"
                  name="status"
                  onChange={handleChange}
                >
                  <option
                    value="active"
                    selected={inputs.status === "active" ? true : false}
                  >
                    Active
                  </option>
                  <option
                    value="inactive"
                    selected={inputs.status === "inactive" ? true : false}
                  >
                    Inactive
                  </option>
                </select>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-3">
                <button
                  className="btn btn-primary btn-block mg-b-10"
                  onClick={formSubmit}
                >
                  <i className="fa fa-send mg-r-10"></i> Create
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BankCreate;